import { Star } from 'lucide-react'
import { googleReviews } from '../data/reviews'

export function GoogleReviews() {
  return (
    <div className="reviews-grid">
      {googleReviews.map((review) => (
        <article className="review-card" key={review.name}>
          <div aria-label="5 yıldız" role="img">
            {Array.from({ length: 5 }).map((_, index) => (
              <Star fill="currentColor" key={index} size={16} />
            ))}
          </div>
          <p>{review.text}</p>
          <strong>{review.name}</strong>
        </article>
      ))}
    </div>
  )
}
